// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Fri Sep 22 2023
 **/

import React, { forwardRef, Ref } from "react";
import { IconProps } from "../Icon";
import Svg from "@/frameworks/designStuff/components/Contents/Icon/Svg";
const CodeExtension = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy: string | undefined = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 36 36"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<rect x={-0.000488281} width={36} height={36} rx={8} fill="#515156" />
				<path
					opacity={0.8}
					d="M14.0319 21.869L7.93485 19.022V17.93L14.0319 14.719V16.604L10.5479 18.398L14.0319 19.997V21.869ZM20.8032 13.588L17.5532 23.13H15.2522L18.5022 13.588H20.8032ZM21.9241 19.997L25.4081 18.398L21.9241 16.604V14.719L28.0211 17.93V19.022L21.9241 21.869V19.997Z"
					fill="white"
				/>
			</Svg>
		);
	}
);
CodeExtension.defaultProps = {
	size: 36,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default CodeExtension;
